/* src/app/private/components/registration/bulk-move-to-application/bulk-move-to-application.component.scss */
/*# sourceMappingURL=bulk-move-to-application.component.css.map */
